<template>
  <div>
    <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
      <div class="col-xs-12 mycol">
        <table
          class="c-indicator content-mb-18 table-indicators-min-cell table-target-years"
        >
          <thead>
            <tr>
              <th class="tab-wid-474">Наименование показателя</th>
              <th
                class="tab-wid-85 th-tc"
                v-for="item in targetYears"
                v-bind:value="item"
                v-bind:key="item"
                v-text="item"
              ></th>
              <th class="tab-wid-197">
                Итого за весь срок<br />
                пользования займом
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="indicator in indicators"
              v-bind:value="indicator.ID"
              v-bind:key="indicator.ID"
            >
              <td>
                <span>{{ indicator.NAME }}</span>
                <!--   начало блока подсказки   -->
                <span
                  v-if="
                    project.UF_HELP &&
                      project.UF_HELP.FIELDS &&
                      project.UF_HELP.FIELDS.STEP2 &&
                      project.UF_HELP.FIELDS.STEP2.INDICATOR &&
                      project.UF_HELP.FIELDS.STEP2.INDICATOR[indicator.ID]
                  "
                  class="h-t-status-info info-holder-container"
                >
                  <span class="info-holder-icon"></span>
                  <span class="info-holder-content info-holder-content_link_l">
                    <span class="info-holder-content__text">
                      {{ project.UF_HELP.FIELDS.STEP2.INDICATOR[indicator.ID] }}
                    </span>
                  </span>
                </span>
                <!--   конец блока подсказки   -->
                <!--                <a-->
                <!--                  v-if="indicator.HELP"-->
                <!--                  class="icon-help-blue"-->
                <!--                  v-tooltip="{ content: indicator.HELP, classes: 'message' }"-->
                <!--                ></a>-->
              </td>
              <td
                v-for="(year, index) in targetYears"
                v-bind:value="year"
                v-bind:key="year"
                v-bind:class="{
                  'has-error': hasIndicatorError(
                    indicator.ID,
                    index,
                    'UF_INDICATORS_VALUE'
                  )
                }"
              >
                <!--  Разделение числа на разряды
    vue-numeric
      separator="space"-->

                <template
                  v-if="$parent.$parent.getProgramCode() == 'improving_ecology'"
                >
                  <vue-numeric
                    separator="space"
                    :precision="indicator.IS_FRACTION === 1 ? 2 : 0"
                    v-bind:key="value.UF_INDICATORS_YEAR"
                    v-for="value in project.INDICATORS.items[indicator.ID]"
                    v-if="value.UF_INDICATORS_YEAR === year"
                    type="text"
                    class="i-main-style"
                    v-model="value.UF_INDICATORS_VALUE"
                    :disabled="
                      indicator.IS_BLOCK == 1 ||
                        $parent.$parent.projectDisabled ||
                        disabledImpovingProgramm(indicator.ID)
                    "
                    @change="removeIndicatorError(indicator.ID, index)"
                    v-on:keypress="
                      isNumber($event, indicator, value.UF_INDICATORS_VALUE)
                    "
                    v-on:keyup="
                      value.UF_INDICATORS_VALUE = checkValue(
                        value.UF_INDICATORS_VALUE,
                        indicator
                      )
                    "
                  />
                </template>
                <template v-else>
                  <vue-numeric
                    separator="space"
                    v-bind:key="value.UF_INDICATORS_YEAR"
                    v-for="value in project.INDICATORS.items[indicator.ID]"
                    v-if="
                      value.UF_INDICATORS_YEAR === year &&
                        $parent.$parent.getProgramCode() !== 'lekarstva'
                    "
                    type="text"
                    class="i-main-style"
                    v-model="value.UF_INDICATORS_VALUE"
                    :disabled="
                      indicator.IS_BLOCK == 1 ||
                        project.INDICATORS.INDICATORS_BLOCK_ID.includes(
                          indicator.ID
                        ) ||
                        $parent.$parent.projectDisabled
                    "
                    @change="removeIndicatorError(indicator.ID, index)"
                    v-on:keypress="
                      isNumber($event, indicator, value.UF_INDICATORS_VALUE)
                    "
                    v-on:keyup.native="
                      value.UF_INDICATORS_VALUE = checkValue(
                        value.UF_INDICATORS_VALUE,
                        indicator
                      )
                    "
                  />
                  <vue-numeric
                    separator="space"
                    v-bind:key="value.UF_INDICATORS_YEAR"
                    v-for="value in project.INDICATORS.items[indicator.ID]"
                    v-if="
                      value.UF_INDICATORS_YEAR === year &&
                        indicator.CODE === 'all_objem' &&
                        disabled() &&
                        $parent.$parent.getProgramCode() === 'lekarstva'
                    "
                    type="text"
                    class="i-main-style"
                    v-model="value.UF_INDICATORS_VALUE"
                    :disabled="
                      indicator.IS_BLOCK == 1 ||
                        $parent.$parent.projectDisabled ||
                        $parent.project.UF_INDUSTRY_ID === 0 ||
                        !$parent.project.UF_INDUSTRY_ID ||
                        (disabledCode21() &&
                          $parent.$parent.getProgramCode() === 'lekarstva')
                    "
                    @change="removeIndicatorError(indicator.ID, index)"
                    v-on:keypress="
                      isNumber($event, indicator, value.UF_INDICATORS_VALUE)
                    "
                    v-on:keyup="
                      value.UF_INDICATORS_VALUE = checkValue(
                        value.UF_INDICATORS_VALUE,
                        indicator
                      )
                    "
                  />
                  <vue-numeric
                    separator="space"
                    v-bind:key="value.UF_INDICATORS_YEAR"
                    v-for="value in project.INDICATORS.items[indicator.ID]"
                    v-if="
                      value.UF_INDICATORS_YEAR === year &&
                        indicator.CODE === 'all_objem' &&
                        disabledCode21() &&
                        $parent.$parent.getProgramCode() === 'lekarstva'
                    "
                    type="text"
                    class="i-main-style"
                    v-model="value.UF_INDICATORS_VALUE"
                    value="0"
                    :disabled="
                      indicator.IS_BLOCK == 1 ||
                        $parent.$parent.projectDisabled ||
                        $parent.project.UF_INDUSTRY_ID === 0 ||
                        !$parent.project.UF_INDUSTRY_ID ||
                        (disabledCode21() &&
                          $parent.$parent.getProgramCode() === 'lekarstva')
                    "
                    @change="removeIndicatorError(indicator.ID, index)"
                    v-on:keypress="
                      isNumber($event, indicator, value.UF_INDICATORS_VALUE)
                    "
                    v-on:keyup="
                      value.UF_INDICATORS_VALUE = checkValue(
                        value.UF_INDICATORS_VALUE,
                        indicator
                      )
                    "
                  />
                  <vue-numeric
                    separator="space"
                    v-bind:key="value.UF_INDICATORS_YEAR"
                    v-for="value in project.INDICATORS.items[indicator.ID]"
                    v-if="
                      value.UF_INDICATORS_YEAR === year &&
                        indicator.CODE === 'all_objem' &&
                        !disabledCode21() &&
                        !disabled() &&
                        $parent.$parent.getProgramCode() === 'lekarstva'
                    "
                    type="text"
                    class="i-main-style"
                    v-model="value.UF_INDICATORS_VALUE"
                    :disabled="
                      indicator.IS_BLOCK == 1 ||
                        $parent.$parent.projectDisabled ||
                        $parent.project.UF_INDUSTRY_ID === 0 ||
                        !$parent.project.UF_INDUSTRY_ID ||
                        (disabledCode21() &&
                          $parent.$parent.getProgramCode() === 'lekarstva')
                    "
                    @change="removeIndicatorError(indicator.ID, index)"
                    v-on:keypress="
                      isNumber($event, indicator, value.UF_INDICATORS_VALUE)
                    "
                    v-on:keyup="
                      value.UF_INDICATORS_VALUE = checkValue(
                        value.UF_INDICATORS_VALUE,
                        indicator
                      )
                    "
                  />
                  <vue-numeric
                    separator="space"
                    v-bind:key="value.UF_INDICATORS_YEAR"
                    v-for="value in project.INDICATORS.items[indicator.ID]"
                    v-if="
                      value.UF_INDICATORS_YEAR === year &&
                        indicator.CODE === 92000 &&
                        disabled() &&
                        $parent.$parent.getProgramCode() === 'lekarstva'
                    "
                    type="text"
                    class="i-main-style"
                    v-model="value.UF_INDICATORS_VALUE"
                    :disabled="
                      indicator.IS_BLOCK == 1 ||
                        $parent.$parent.projectDisabled ||
                        $parent.project.UF_INDUSTRY_ID === 0 ||
                        !$parent.project.UF_INDUSTRY_ID ||
                        (disabledCode21() &&
                          $parent.$parent.getProgramCode() === 'lekarstva')
                    "
                    @change="removeIndicatorError(indicator.ID, index)"
                    v-on:keypress="
                      isNumber($event, indicator, value.UF_INDICATORS_VALUE)
                    "
                    v-on:keyup="
                      value.UF_INDICATORS_VALUE = checkValue(
                        value.UF_INDICATORS_VALUE,
                        indicator
                      )
                    "
                  />

                  <vue-numeric
                    separator="space"
                    v-bind:key="value.UF_INDICATORS_YEAR"
                    v-for="value in project.INDICATORS.items[indicator.ID]"
                    v-if="
                      value.UF_INDICATORS_YEAR === year &&
                        indicator.CODE === 92000 &&
                        !disabled() &&
                        !disabledCode21() &&
                        $parent.$parent.getProgramCode() === 'lekarstva'
                    "
                    type="text"
                    class="i-main-style"
                    v-model="value.UF_INDICATORS_VALUE"
                    :disabled="
                      indicator.IS_BLOCK == 1 ||
                        $parent.$parent.projectDisabled ||
                        $parent.project.UF_INDUSTRY_ID === 0 ||
                        !$parent.project.UF_INDUSTRY_ID ||
                        disabledCode21()
                    "
                    @change="removeIndicatorError(indicator.ID, index)"
                    v-on:keypress="
                      isNumber($event, indicator, value.UF_INDICATORS_VALUE)
                    "
                    v-on:keyup="
                      value.UF_INDICATORS_VALUE = checkValue(
                        value.UF_INDICATORS_VALUE,
                        indicator
                      )
                    "
                  />

                  <vue-numeric
                    separator="space"
                    v-bind:key="value.UF_INDICATORS_YEAR"
                    v-for="value in project.INDICATORS.items[indicator.ID]"
                    v-if="
                      value.UF_INDICATORS_YEAR === year &&
                        indicator.CODE === 92000 &&
                        disabledCode21() &&
                        $parent.$parent.getProgramCode() === 'lekarstva'
                    "
                    type="text"
                    class="i-main-style"
                    v-model="value.UF_INDICATORS_VALUE"
                    value="0"
                    :disabled="
                      indicator.IS_BLOCK == 1 ||
                        $parent.$parent.projectDisabled ||
                        $parent.project.UF_INDUSTRY_ID === 0 ||
                        !$parent.project.UF_INDUSTRY_ID ||
                        (disabledCode21() &&
                          $parent.$parent.getProgramCode() === 'lekarstva')
                    "
                    @change="removeIndicatorError(indicator.ID, index)"
                    v-on:keypress="
                      isNumber($event, indicator, value.UF_INDICATORS_VALUE)
                    "
                    v-on:keyup="
                      value.UF_INDICATORS_VALUE = checkValue(
                        value.UF_INDICATORS_VALUE,
                        indicator
                      )
                    "
                  />
                  <vue-numeric
                    separator="space"
                    v-bind:key="value.UF_INDICATORS_YEAR"
                    v-for="value in project.INDICATORS.items[indicator.ID]"
                    v-if="
                      value.UF_INDICATORS_YEAR === year &&
                        indicator.CODE !== 'all_objem' &&
                        indicator.CODE !== 92000 &&
                        !disabledCode21() &&
                        $parent.$parent.getProgramCode() === 'lekarstva'
                    "
                    type="text"
                    class="i-main-style"
                    v-model="value.UF_INDICATORS_VALUE"
                    value="0"
                    :disabled="
                      indicator.IS_BLOCK == 1 ||
                        $parent.$parent.projectDisabled ||
                        $parent.project.UF_INDUSTRY_ID === 0 ||
                        !$parent.project.UF_INDUSTRY_ID ||
                        disabledCodeMarkirovkaOther() ||
                        (disabledCode21() &&
                          $parent.$parent.getProgramCode() === 'lekarstva')
                    "
                    @change="
                      removeIndicatorError(
                        indicator.ID,
                        index,
                        value.UF_INDICATORS_VALUE
                      )
                    "
                    v-on:keypress="
                      isNumber($event, indicator, value.UF_INDICATORS_VALUE)
                    "
                    v-on:keyup="
                      value.UF_INDICATORS_VALUE = checkValue(
                        value.UF_INDICATORS_VALUE,
                        indicator
                      )
                    "
                  />

                  <vue-numeric
                    separator="space"
                    v-bind:key="value.UF_INDICATORS_YEAR"
                    v-for="value in project.INDICATORS.items[indicator.ID]"
                    v-if="
                      value.UF_INDICATORS_YEAR === year &&
                        indicator.CODE !== 'all_objem' &&
                        indicator.CODE !== 92000 &&
                        disabledCode21() &&
                        $parent.$parent.getProgramCode() === 'lekarstva'
                    "
                    type="text"
                    class="i-main-style"
                    v-model="value.UF_INDICATORS_VALUE"
                    :disabled="
                      indicator.IS_BLOCK == 1 ||
                        $parent.$parent.projectDisabled ||
                        $parent.project.UF_INDUSTRY_ID === 0 ||
                        !$parent.project.UF_INDUSTRY_ID ||
                        disabledCodeMarkirovkaOther() /*||
                        (disabledCode21() &&
                          $parent.$parent.getProgramCode() === 'lekarstva')*/
                    "
                    @change="removeIndicatorError(indicator.ID, index)"
                    v-on:keypress="
                      isNumber($event, indicator, value.UF_INDICATORS_VALUE)
                    "
                    v-on:keyup="
                      value.UF_INDICATORS_VALUE = checkValue(
                        value.UF_INDICATORS_VALUE,
                        indicator
                      )
                    "
                  />
                </template>
              </td>
              <td>{{ calcIndicatorValues(indicator.ID) | toCurrency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      class="row myrow content-mb-42"
      v-show="$parent.RESULT_INTELLECTUAL_ACTIVITY"
    >
      <div class="col-xs-12 mycol">
        <p class="content-s-2-label">
          <label
            >Сведения о результатах интеллектуальной деятельности
            <span
              v-if="
                project.UF_HELP &&
                  project.UF_HELP.FIELDS &&
                  project.UF_HELP.FIELDS.STEP2['INTELECTUAL_RESULT']
              "
              class="h-t-status-info info-holder-container"
            >
              <span class="info-holder-icon"></span>
              <span class="info-holder-content info-holder-content_link_l">
                <span class="info-holder-content__text">
                  {{ project.UF_HELP.FIELDS.STEP2["INTELECTUAL_RESULT"] }}
                </span>
              </span>
            </span>
          </label>
        </p>
        <table class="co-executor">
          <thead>
            <tr>
              <td>
                Наименование результата интеллектуальной деятельности (РИД)
              </td>
              <td>Форма результата интеллектуальной деятельности (РИД)</td>
              <td v-if="$parent.project.UF_SETTING.IS_HIDE_PLAN_DATA_RID !== 1">
                Плановая дата получения результата интеллектуальной деятельности
                (РИД)
              </td>
              <td>
                Собственник результата интеллектуальной деятельности (РИД)
              </td>
              <td v-show="false">
                Резидентство (страна) собственника результата интеллектуальной
                деятельности (РИД)
              </td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in project.INTELECTUAL_RESULT"
              v-bind:key="index"
            >
              <td>
                <input type="hidden" v-model="item.ID" />

                <textarea-autosize
                  type="text"
                  class="i-main-style"
                  style="width: 90%; min-height: 40px;"
                  v-model="item.UF_NAME"
                  :disabled="$parent.$parent.projectDisabled"
                />
              </td>
              <td>
                <select
                  class="sel-dropdown i-main-style i-wid-100"
                  v-if="
                    $parent.$parent.project.UF_SETTING.IS_VIEW_SP_VID_RES_RID &&
                      $parent.$parent.project.UF_SETTING
                        .IS_VIEW_SP_VID_RES_RID == 1
                  "
                  v-model="item.UF_NAME_VID_RES_RID_ID"
                  :disabled="$parent.$parent.projectDisabled"
                >
                  <option
                    v-for="item1 in directory.sp_vid_result_intellectual_rid"
                    v-if="
                      !getFindProgramm(item1) ||
                        item1.ID === item.UF_NAME_VID_RES_RID_ID
                    "
                    v-bind:key="item1.ID"
                    v-bind:value="item1.ID"
                    v-text="item1.NAME"
                  ></option>
                </select>

                <input
                  v-else
                  type="text"
                  class="i-main-style i-co-executor-style"
                  v-model="item.UF_FORMA"
                  :disabled="$parent.$parent.projectDisabled"
                />
              </td>
              <td v-if="$parent.project.UF_SETTING.IS_HIDE_PLAN_DATA_RID !== 1">
                <input
                  type="text"
                  class="i-main-style i-co-executor-style"
                  v-model="item.UF_PLAN_DATE"
                  :disabled="$parent.$parent.projectDisabled"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="i-main-style i-co-executor-style"
                  style="width: 90%"
                  v-model="item.UF_OWNER"
                  :disabled="true"
                />
              </td>
              <td v-show="false">
                <select
                  v-model="item.UF_COUNTRY_ID"
                  class="i-main-style sel-dropdown"
                  :disabled="$parent.$parent.projectDisabled"
                >
                  <option
                    v-for="item in directory.country"
                    v-bind:value="item.ID"
                    v-bind:key="item.ID"
                    v-text="item.NAME"
                  ></option>
                </select>
              </td>
              <td v-show="false">
                <a
                  v-on:click="deleteIntellectualResult(index)"
                  class="link-delete-row"
                ></a>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="add-row" v-show="false">
          <a v-on:click="addIntellectualResult" class="link-add-row"
            >Добавить сведения о результатах интеллектуальной деятельности</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { FETCH_DIRECTORIES } from "@/store/actions.type";

export default {
  name: "target_years",
  data() {
    return {
      countRidAddHistory: [0, 0]
    };
  },
  methods: {
    isAllowed(item) {
      // if (
      //   this.$parent.$parent.getProgramCode(
      //     this.$parent.project.UF_SUPPORT_PROG_ID
      //   ) !== "working" &&
      //   this.$parent.$parent.getProgramCode(
      //     this.$parent.project.UF_SUPPORT_PROG_ID
      //   ) !== "working_rfrp"
      // )
      switch (item.CODE) {
        case 17:
          return true;
        case 22:
          return true;
        case 25:
          return true;
        case 37:
          return true;
        case 38:
          return true;
        default:
          return false;
      }
    },
    disabled() {
      let d = false;
      this.$parent.directory.tree_industry.forEach(el => {
        if (el.ID === this.$parent.project.UF_INDUSTRY_ID) {
          switch (el.CODE) {
            case 17:
              return (d = true);
            case 22:
              return (d = true);
            case 25:
              return (d = true);
            case 37:
              return (d = true);
            case 38:
              return (d = true);
            default:
              return (d = false);
          }
        }
      });
      return d;
    },

    disabledCode21() {
      let d = false;
      this.$parent.directory.tree_industry.forEach(el => {
        if (el.ID === this.$parent.project.UF_INDUSTRY_ID) {
          switch (el.CODE) {
            case 21:
              return (d = true);
            default:
              return (d = false);
          }
        }
      });
      return d;
    },
    disabledCodeMarkirovkaOther() {
      let d = false;
      this.$parent.directory.tree_industry.forEach(el => {
        if (el.ID === this.$parent.project.UF_INDUSTRY_ID) {
          switch (el.CODE) {
            case "markirovka_other":
              return (d = true);
            default:
              return (d = false);
          }
        }
      });
      return d;
    },
    disabledImpovingProgramm(indicator_ID) {
      let d = false;

      this.$parent.directory.start_pokazatel.forEach(el2 => {
        if (
          (el2.CODE == "fp_1" || el2.CODE == "fp_2") &&
          indicator_ID == el2.ID
        ) {
          d = true;
        }
      });

      this.$parent.directory.sp_federal_project.forEach(el => {
        if (el.ID == this.$parent.project.UF_FEDERAL_PRJ_ID) {
          this.$parent.directory.start_pokazatel.forEach(el2 => {
            if (el.CODE == el2.CODE && indicator_ID == el2.ID) {
              return (d = false);
            }
          });
        }
      });
      return d;
    },
    addIntellectualResult() {
      if (typeof this.project.INTELECTUAL_RESULT === "undefined") {
        this.project.INTELECTUAL_RESULT = [];
      }
      this.project.INTELECTUAL_RESULT.push({
        UF_OWNER: this.$parent.project.ORG_INFO.UF_NAME
      });
    },
    deleteIntellectualResult(index) {
      this.project.INTELECTUAL_RESULT.splice(index, 1);
      if (this.project.INTELECTUAL_RESULT.length === 0) {
        this.project.INTELECTUAL_RESULT.push({
          UF_OWNER: this.$parent.project.ORG_INFO.UF_NAME
        });
      }
    },
    hasIndicatorError(id, index, field) {
      if (typeof this.$parent.$parent.indicatorsErrors[id] !== "undefined") {
        if (
          typeof this.$parent.$parent.indicatorsErrors[id][index] !==
          "undefined"
        ) {
          if (
            typeof this.$parent.$parent.indicatorsErrors[id][index][field] !==
            "undefined"
          ) {
            return true;
          }
        }
      }
      return false;
    },
    removeIndicatorError(id, index, value) {
      if (value) {
        value = 0;
      }
      if (typeof this.$parent.$parent.indicatorsErrors[id] !== "undefined") {
        if (typeof this.$parent.$parent.indicatorsErrors[id] !== "undefined") {
          Vue.delete(this.$parent.$parent.indicatorsErrors, id);
        }
      }
      return false;
    },
    calcIndicatorValues(id) {
      let sum = 0;
      let indicator = this.getIndicator(id);
      let _this = this;
      if (indicator.FORMULA != null) {
        _this.calcIndicatorByFormula(indicator);
      }
      if (indicator.ACTION_ROW.length !== 0) {
        sum = _this.calcIndicatorValueByActionRow(indicator);
      } else {
        this.project.INDICATORS.items[id].forEach(function(v) {
          if (
            v.UF_INDICATORS_YEAR >= _this.project.INDICATORS.yearStart &&
            v.UF_INDICATORS_YEAR <= _this.project.INDICATORS.yearEnd
          ) {
            if (v.UF_INDICATORS_VALUE == "") {
              v.UF_INDICATORS_VALUE = 0;
            }
            sum += Number(v.UF_INDICATORS_VALUE);
          }
        });
      }
      if (indicator.ACTION.length !== 0) {
        _this.applyIndicatorActions(indicator, sum);
      }
      if (
        indicator.IS_PROCENT === 1 &&
        !indicator.IS_PROCENT_FORMULA &&
        !indicator.ACTION_ROW.length
      ) {
        sum = 0;
        let f = 0;
        this.project.INDICATORS.items[id].forEach(function(v) {
          let s = v.UF_INDICATORS_VALUE;
          if (s === "" || s == 0) {
            return;
          }
          sum += Number(s);
          f++;
        });
        if (f > 0) {
          sum = (sum / f).toFixed(1);
        }
      }
      // Разделение числа на разряды js
      return sum;
    },
    calcIndicatorByFormula(indicator) {
      let _this = this;
      this.project.INDICATORS.items[indicator.ID].forEach(function(mItem, k) {
        let formula = indicator.FORMULA;
        Object.values(_this.project.INDICATORS.items).forEach(function(item) {
          item.forEach(function(v) {
            if (v.UF_INDICATORS_YEAR === mItem.UF_INDICATORS_YEAR) {
              let s = v.UF_INDICATORS_VALUE;
              if (s === "") {
                s = 0;
              }
              formula = formula.replace(
                "{{ " + v.UF_INDICATORS_ID.toString() + " }}",
                Number.parseFloat(s).toString()
              );
            }
          });
        });
        _this.project.INDICATORS.items[indicator.ID][
          k
        ].UF_INDICATORS_VALUE = eval(formula);
      });
    },
    calcIndicatorValueByActionRow(indicator) {
      let _this = this;
      let action = "";
      indicator.ACTION_ROW.forEach(function(row) {
        if (row.type === "sum") {
          let value = 0;
          _this.project.INDICATORS.items[indicator.ID].forEach(function(mItem) {
            if (
              Number.parseFloat(mItem.UF_INDICATORS_VALUE).toString() === "NaN"
            ) {
              mItem.UF_INDICATORS_VALUE = 0;
            }
            let formula = row.formula
              .replace(/\s/g, "")
              .replace(
                "{{value}}",
                Number.parseFloat(mItem.UF_INDICATORS_VALUE).toString()
              );
            Object.values(_this.project.INDICATORS.items).forEach(function(
              item
            ) {
              item.forEach(function(v) {
                if (v.UF_INDICATORS_YEAR === mItem.UF_INDICATORS_YEAR) {
                  if (
                    Number.parseFloat(v.UF_INDICATORS_VALUE).toString() ===
                    "NaN"
                  ) {
                    v.UF_INDICATORS_VALUE = 0;
                  }
                  formula = formula.replace(
                    "{{" + v.UF_INDICATORS_ID.toString() + "}}",
                    Number.parseFloat(v.UF_INDICATORS_VALUE).toString()
                  );
                }
              });
            });
            try {
              value += eval(formula);
            } catch (e) {
              console.log(e);
            }
          });
          console.log("value", value);
          if (indicator.IS_PROCENT_FORMULA) {
            value = value / 100;
          }

          action += value.toString();
        } else if (row.type === "maxYearNotNull") {
          action = 0;
          _this.project.INDICATORS.items[indicator.ID].forEach(function(mItem) {
            if (
              Number.parseFloat(mItem.UF_INDICATORS_VALUE).toString() === "NaN"
            ) {
              mItem.UF_INDICATORS_VALUE = 0;
            }
            if (mItem.UF_INDICATORS_VALUE > action) {
              action = mItem.UF_INDICATORS_VALUE;
            }
          });
        } else if (row.type === "basicYearCalculation") {
          action = 0;
          let multuplyWork = 1;
          if (_this.project.UF_BASE_YEAR > 0) {
            _this.project.INDICATORS.items[indicator.ID].forEach(function(
              mItem
            ) {
              if (
                Number.parseFloat(mItem.UF_INDICATORS_VALUE).toString() ===
                "NaN"
              ) {
                mItem.UF_INDICATORS_VALUE = 0;
              }

              if (mItem.UF_INDICATORS_YEAR > _this.project.UF_BASE_YEAR + 2) {
                let valueTemp = mItem.UF_INDICATORS_VALUE / 100 + 1;
                multuplyWork = multuplyWork * valueTemp;
              }
            });
            action = (multuplyWork - 1) * 100;
          }
        } else if (row.type === "LastYearNotNull") {
          action = 0;
          _this.project.INDICATORS.items[indicator.ID].forEach(function(mItem) {
            if (
              Number.parseFloat(mItem.UF_INDICATORS_VALUE).toString() === "NaN"
            ) {
              mItem.UF_INDICATORS_VALUE = 0;
            }
            if (mItem.UF_INDICATORS_VALUE > 0) {
              action = mItem.UF_INDICATORS_VALUE;
            }
          });
        } else {
          action += row.type;
        }
      });
      let val = 0;
      try {
        console.log(indicator.ACTION_ROW_CONVERT);
        val = eval(action).toFixed(indicator.ACTION_ROW_CONVERT);
      } catch (e) {
        console.log(e);
      }
      if (val === "NaN") {
        return 0;
      }
      return val;
    },
    applyIndicatorActions(indicator, sum) {
      let _this = this;
      indicator.ACTION.forEach(function(row) {
        switch (row.type) {
          case "showModel": {
            let apply = true;
            row.where.forEach(function(w) {
              if (!apply) return;
              switch (w.type) {
                case "valueNotNull": {
                  if (sum === 0) {
                    apply = false;
                  }
                  break;
                }
                case "notProgramFieldValue": {
                  if (typeof _this.project[w.field] === "undefined") {
                    apply = false;
                    break;
                  }
                  if (_this.project[w.field] === w.value) {
                    apply = false;
                  }
                  break;
                }
                default: {
                  break;
                }
              }
            });
            this.$parent[row.value] = apply;

            //создание автоматических строк в РИД ---
            let countRID = sum > 50 ? 50 : sum;
            this.countRidAddHistory[1] = this.countRidAddHistory[0];
            this.countRidAddHistory[0] = countRID;

            console.log("Начало отладки");
            console.log(this.project.INTELECTUAL_RESULT.length);
            console.log(countRID);
            console.log("Окончание отладки");

            if (
              sum > 0 &&
              countRID > 0 &&
              apply &&
              row.value == "RESULT_INTELLECTUAL_ACTIVITY"
            ) {
              //65800 добавлеение пустых строк
              if (
                typeof this.project.INTELECTUAL_RESULT === "undefined" ||
                this.project.INTELECTUAL_RESULT.length == 0
              ) {
                let i = 0;
                while (i < countRID) {
                  this.addIntellectualResult();
                  i++;
                }
              } else if (
                this.project.INTELECTUAL_RESULT.length > 0 &&
                this.project.INTELECTUAL_RESULT.length < countRID
              ) {
                let i = this.project.INTELECTUAL_RESULT.length;
                while (i < countRID) {
                  this.addIntellectualResult();
                  i++;
                }
              } else if (this.project.INTELECTUAL_RESULT.length > countRID) {
                //let delCount = this.countRidAddHistory[1] - this.countRidAddHistory[0];
                //удалить пустые строки
                let delCount =
                  this.project.INTELECTUAL_RESULT.length - countRID;

                console.log("delCount: " + delCount);

                if (delCount > 0) {
                  this.project.INTELECTUAL_RESULT.forEach(function(obj, indx) {
                    if (/*Object.keys(obj).length === 0 &&*/ delCount > 0) {
                      if (
                        indx >=
                        this.project.INTELECTUAL_RESULT.length - delCount
                      ) {
                        this.deleteIntellectualResult(indx);
                        delCount--;
                      }
                    }
                  }, this);
                }
              }
            }
            break;
          }
          default: {
            break;
          }
        }
      }, this);
    },
    checkValue: function(val, indicator) {
      if (indicator.IS_PROCENT === 1 && val > 100) {
        val = 100;
      }

      if (indicator.CODE == "intelectual" && val > 50) {
        val = 50;
      }
      console.log(indicator);
      return val;
    },
    getIndicator(id) {
      let t = this.directory.start_pokazatel.filter(c => c.ID === id);
      if (t.length > 0 && t[0].URL !== null) {
        return t[0];
      }
    },
    isNumber: function(evt, indicator, val) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;

      if (indicator.IS_PROCENT === 0 && charCode === 46) {
        evt.preventDefault();
        return false;
      }
      if (
        indicator.IS_PROCENT === 1 &&
        charCode === 46 &&
        typeof val.indexOf !== "undefined" &&
        val.indexOf(".") !== -1
      ) {
        evt.preventDefault();
        return false;
      }
      if (indicator.IS_PROCENT === 1 && charCode === 46) {
        return true;
      }

      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getFindProgramm(item) {
      let t = item.IS_NOT_VIEW_SUPPORT_PROGRAM.filter(
        c => c === this.$parent.$parent.project.UF_SUPPORT_PROG_ID
      );
      return t.length > 0 ? true : false;
    }
  },
  computed: {
    ...mapGetters(["directory", "project"]),
    targetYears() {
      let years = [];
      for (
        let i = this.project.INDICATORS.yearStart;
        i <= this.project.INDICATORS.yearEnd;
        i++
      ) {
        years.push(i);
      }
      return years;
    },
    indicators() {
      let p = this.project;
      let t = [];
      if (!p.INDICATORS.INDICATORS_ID) {
        return t;
      }

      p.INDICATORS.INDICATORS_ID.forEach(function(v) {
        this.directory.start_pokazatel.forEach(function(c) {
          if (c.ID === v) {
            t.push(c);
          }
        });
      }, this);
      return t;
    }
  },
  async created() {
    await this.$store.dispatch(FETCH_DIRECTORIES, [
      "country",
      "sp_vid_result_intellectual_rid"
    ]);
  }
};
</script>

<style scoped></style>
